import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import axios from 'axios';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Table, { TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel } from 'material-ui/Table';
import Select from 'material-ui/Select';

import {saveData} from './actions';

class Question5 extends Component {

  constructor(props){
    super(props);

    this.state = {
      popCount: "Loading...",
      current_level: "",
      income: 0,
      page: 0,
      rowsPerPage: 5,
      showPopulation: false,
      popLoaded: false,
      levels: ["Everyone","Up to $25,000","$25,000 and above","$35,000 and above","$50,000 and above","$75,000 and above","$100,000 and above","$150,000 and above"],
    };
  }

  componentDidMount() {

    this.setState({
      current_level: this.state.levels[0]
    });
  }

  handleChange = event => {

    this.setState({
      current_level: event.target.value,
      income: this.state.levels.indexOf(event.target.value)
    }, function() {

    });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  onApplyFilter() {

    //oar_low: 0,oar_high:10,age_low:0,age_high: 75,pref_age:0,income: 0, education: 0,pref_fans: 0
    this.props.saveData(0,10,0,75,0,this.state.income,0,0);
    this.props.changeRoute("/console/display/adhoc_filters/notifications")
  }

  render(){
    const { classes, theme, location } = this.props;
    const { rowsPerPage, page, showPopulation } = this.state;

    return(
      <div className={classes.root}>
        <Typography type="body2" color="inherit" className={classes.flex}>
          6. Income
        </Typography>
        <br/>
        <Typography>You can check the user distribution of the salary level by tapping the button below:</Typography>
        <div className={classes.buttonDistribution}>
          <Button raised onClick={() => this.props.changeRoute("/console/display/adhoc_filters/distribution_6")} color="primary" align="center" className={classes.button}>See Distribution</Button>
        </div>
        <Typography>Select the minimum income level:</Typography>
        <form className={classes.container} autoComplete="off">
          <FormControl className={classes.youngest}>
            <InputLabel htmlFor="salary-rating">Income Level</InputLabel>
            <Select
              value={this.state.current_level}
              onChange={this.handleChange}
              input={<Input name="salary" id="salary-rating" />}
            >
              {this.state.levels.map(item => {
                return <MenuItem value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
        </form>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.onApplyFilter()} color="primary" align="center" className={classes.button}>Apply Filter</Button>
          <Button raised onClick={() => this.props.changeRoute('/console/display/adhoc_filters')} color="primary" align="center" className={classes.button}>Select a different Filter</Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}


function matchDispatchToProps(dispatch){
  return {
    saveData: bindActionCreators(saveData, dispatch),
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Question5)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Question6/index.js